import dialogDrag, { initAdminDialogDrag } from './dialogDrag'

export function registerDirectives(Vue) {
  Vue.directive('dialog-drag', dialogDrag)
  initAdminDialogDrag()
}
